<div class="dialog-title">
  <span>Reset Password</span>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div matDialogContent>
  <form class="reset-form" [formGroup]="formGroup">
    <mat-form-field appearance="outline">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="password">
      <mat-hint>Password must be at least 16 characters</mat-hint>
      <mat-error>
        @if (formGroup.get('password')?.hasError('required')) {
          <span>password is required</span>
        }
        @if (formGroup.get('password')?.hasError('passwordComplexity')) {
          <span>
            {{ formGroup.get('password')?.getError('passwordComplexity') }}
          </span>
        }
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="confirm">
      <mat-error>
        @if (formGroup.get('confirm')?.hasError('required')) {
          <span>confirm password is required</span>
        }
        @if (formGroup.get('confirm')?.hasError('match')) {
          <span>password must match</span>
        }
      </mat-error>
    </mat-form-field>
  </form>
</div>


<div matDialogActions class="dialog-actions">
  <button mat-flat-button color="primary" [disabled]="formGroup.invalid || formGroup.pending" (click)="resetPassword()">
    Submit
  </button>
</div>
